import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface OpenTaskPanelFromOOSEntityParams {
  selection: string;
  warehouseId: number | null;
  warehouseLocationCode: string | null;
  inventoryId: number;
  distributorId: number;
}
export class OpenTaskPanelFromOOSEntity extends BaseEntityClass {
  selection: string;
  warehouseId: number | null;
  warehouseLocationCode: string | null;
  inventoryId: number;
  distributorId: number;
  constructor(params: OpenTaskPanelFromOOSEntityParams) {
    super();
    this.type = "open_task_panel_from_oos";
    this.entity_version = 1;
    this.selection = params.selection;
    this.warehouseId = params.warehouseId;
    this.warehouseLocationCode = params.warehouseLocationCode;
    this.inventoryId = params.inventoryId;
    this.distributorId = params.distributorId;
  }
}
